import {HOMOYNM_BOX_MIN_PADDING, HOMONYM_BOX_PADDING, HOMONYM_BOX_MAX_PADDING_TOP} from '../defines/client.const';
import {Word} from './word.model';
import {IsEmptyString} from "../defines/common.func";

const HOMONYM_SMALL = 3;

export class Homonym {

  // 서버에서 보내주는 값
  name: string;
  listWord: Array<Word>;

  // 내부 처리용
  overSize = false;

  constructor(obj?: any) {
    this.name           = (obj && obj.name)         ?? null;

    this.listWord       = new Array<Word>();
    if ('words' in obj) {
      obj.words.forEach((value: any) => this.listWord.push(new Word(value)));
    }

    // console.log('Homonym()', obj, this);
  }

  public get hasVoice(): boolean {
    return this.listWord.some(word => !IsEmptyString(word.wordVoice));
  }
}

